import React from 'react';

import { type WalletItem } from '@app/store/types/user';

import { Account, Ellipsis } from './styles';

const ACCOUNT_LENGTH = 6;

type WalletAccountLabelProps = {
    account: WalletItem;
} & React.ComponentProps<typeof Account>;

export const WalletAccountLabel = ({ account, ...others }: WalletAccountLabelProps) => (
    <Account title={account} {...others}>
        <Ellipsis>{account.slice(0, Math.max(0, account.length - ACCOUNT_LENGTH))}</Ellipsis>
        <span>{account.slice(Math.max(0, account.length - ACCOUNT_LENGTH))}</span>
    </Account>
);
